export const getTimeOfDay = (date: Date = new Date()): string => {
  const h = date.getHours();
  if (h < 12) {
    return 'Good Morning';
  }
  if (h >= 12 && h < 17) {
    return 'Good Afternoon';
  }
  return 'Good Evening';
};
